export interface CampaignHeaders {
  Accept: 'application/json'
  'Content-Type': 'application/json'
  'X-Raund-Token': string
  'X-Local': string
  'X-Raund-Campaign': string
  'X-Raund-Client-Id': string
  [key: string]: string
}
export interface CampaignHeadersWithAuthorization extends CampaignHeaders {
  Authorization: string
}

/**
 * `useCampaignHeaders.ts`で呼ばれる。共通化のための関数
 * */
export const getHeaders = ({
  campaignSlug,
  uuid,
  locale,
}: { campaignSlug: string; uuid: string; locale: string }): CampaignHeaders => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
    'X-Raund-Campaign': campaignSlug,
    'X-Raund-Client-Id': uuid,
    'X-Local': locale,
  }
}

/**
 * `useCampaignHeaders.ts`で呼ばれる。共通化のための関数
 * */
export const getHeadersWithAuthorization = ({
  campaignSlug,
  uuid,
  locale,
  idToken,
}: { campaignSlug: string; uuid: string; locale: string; idToken: string }): CampaignHeadersWithAuthorization => {
  return {
    ...getHeaders({ campaignSlug, uuid, locale }),
    Authorization: `Bearer ${idToken}`,
  }
}
